
    import { defineComponent } from 'vue';
    import SettingsService from '@/apps/shared/services/getSettings-service';
    export default defineComponent({
        name: 'Footer',
        busEvents: {
            updateByProductGoogleAnalytics(productGTMName) {
                this.updateGoogleAnalytics(productGTMName);
            }
        },
        data() {
            return {
                dateNow: new Date(),
                srcGoogleAnalytics: null,
            }
        },
        methods: {
            updateGoogleAnalytics(productGTMName) {
                SettingsService.getSettings(productGTMName + ":IdGTM")
                    .then(response => {
                        this.activateGtm(window, document, 'script', 'dataLayer', response);
                        this.srcGoogleAnalytics = "https://www.googletagmanager.com/ns.html?id=" + response;
                    });
            },
            activateGtm(w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            },
        },
    });
